var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import axios from 'axios';
import { SystemIcon } from '@storeblocks/icon';
import InlineAlert from '@storeblocks/inline-alert';
import { getText } from '@storebrand-digital/fms-translations';
import { FileNameWrap, Wrap } from './styled';
import { formatDateTime } from '../../containers/Inbox/Items';
function Attachments(_a) {
    var _this = this;
    var attachments = _a.attachments, taskId = _a.taskId, right = _a.right, date = _a.date;
    var _b = useState(undefined), error = _b[0], setError = _b[1];
    var _c = useState(false), fileNotReady = _c[0], setFileNotReady = _c[1];
    function createFileUrl(fileContent) {
        var byteArray = Uint8Array.from(atob(fileContent)
            .split('')
            .map(function (char) { return char.charCodeAt(0); }));
        var blob = new Blob([byteArray]);
        return URL.createObjectURL(blob);
    }
    function downloadFile(fileContent, fileName) {
        var url = createFileUrl(fileContent);
        var link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();
    }
    var onAttachmentClick = function (fileId, fileName) { return function (e) { return __awaiter(_this, void 0, void 0, function () {
        var regex, response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    regex = /^[a-z,0-9,-]{36,36}$/;
                    if (!(fileId && !regex.test(fileId))) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get("/customer/messages/files/".concat(taskId, "/files/").concat(fileId))];
                case 2:
                    response = _a.sent();
                    downloadFile(response.data.fileContent, fileName);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    setError(err_1);
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 6];
                case 5:
                    setFileNotReady(true);
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); }; };
    return (React.createElement(React.Fragment, null,
        attachments.map(function (_a) {
            var fileName = _a.fileName, fileId = _a.fileId;
            return (React.createElement(Wrap, { href: "#", key: fileId, onClick: onAttachmentClick(fileId, fileName), "$right": right },
                React.createElement(FileNameWrap, null,
                    React.createElement(SystemIcon, { name: "attachment", size: 22, mr: "16px" }),
                    React.createElement("span", { "data-hj-suppress": true }, fileName)),
                date && React.createElement("span", null, formatDateTime(date, 'dd.MM.yyyy'))));
        }),
        error && (React.createElement(InlineAlert, { title: getText('chat.download.error'), variant: "error" })),
        fileNotReady && (React.createElement(InlineAlert, { title: getText('chat.download.not-ready'), variant: "error" }))));
}
export default Attachments;
